// src/pages/PozisyonYonetimiPage.js
import React, { useState, useEffect, useCallback } from 'react';

const API = '';

const seviyeRenk = (sev) => {
  const r = { 1: '#DC2626', 2: '#D97706', 3: '#059669', 4: '#2563EB', 5: '#7C3AED' };
  return r[sev] || '#6B7280';
};

const seviyeAd = (sev) => {
  const a = { 1: 'C-Level / Board', 2: 'Direktör / VP', 3: 'Müdür / Lead', 4: 'Kıdemli', 5: 'Uzman' };
  return a[sev] || `Seviye ${sev}`;
};

export default function PozisyonYonetimiPage() {
  const [pozisyonlar, setPozisyonlar] = useState([]);
  const [departmanlar, setDepartmanlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modalAcik, setModalAcik] = useState(false);
  const [secili, setSecili] = useState(null);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [aramaMetni, setAramaMetni] = useState('');
  const [filtreDep, setFiltreDep] = useState('');
  const [filtreSeviye, setFiltreSeviye] = useState('');
  const [gorunum, setGorunum] = useState('agac');
  const [form, setForm] = useState({
    ad: '', kod: '', departman_id: '', ust_pozisyon_id: '',
    seviye: 1, aciklama: '', min_maas: '', max_maas: ''
  });

  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  const getir = useCallback(async () => {
    try {
      setYukleniyor(true);
      const [pozR, depR] = await Promise.all([
        fetch(`${API}/api/organizasyon/pozisyonlar?hepsi=1`, { headers }),
        fetch(`${API}/api/organizasyon/departmanlar`, { headers })
      ]);
      const [poz, dep] = await Promise.all([pozR.json(), depR.json()]);
      setPozisyonlar(Array.isArray(poz) ? poz : []);
      setDepartmanlar(Array.isArray(dep) ? dep : []);
    } catch { setHata('Veriler yüklenemedi'); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => { getir(); }, [getir]);

  const filtrelenmis = pozisyonlar.filter(p => {
    const aramaUyum = !aramaMetni || p.ad.toLowerCase().includes(aramaMetni.toLowerCase()) || p.kod.toLowerCase().includes(aramaMetni.toLowerCase());
    const depUyum = !filtreDep || String(p.departman_id) === String(filtreDep);
    const sevUyum = !filtreSeviye || String(p.seviye) === String(filtreSeviye);
    return aramaUyum && depUyum && sevUyum;
  });

  const agacOlustur = (pozlar, ustId = null, derinlik = 0) => {
    return pozlar
      .filter(p => (ustId === null ? !p.ust_pozisyon_id : String(p.ust_pozisyon_id) === String(ustId)))
      .sort((a, b) => a.seviye - b.seviye || a.ad.localeCompare(b.ad))
      .map(p => ({ ...p, derinlik, cocuklar: agacOlustur(pozlar, p.id, derinlik + 1) }));
  };

  const yeniAc = () => {
    setSecili(null);
    setForm({ ad: '', kod: '', departman_id: '', ust_pozisyon_id: '', seviye: 1, aciklama: '', min_maas: '', max_maas: '' });
    setHata(''); setBasari('');
    setModalAcik(true);
  };

  const duzenleAc = (poz) => {
    setSecili(poz);
    setForm({
      ad: poz.ad, kod: poz.kod, departman_id: poz.departman_id,
      ust_pozisyon_id: poz.ust_pozisyon_id || '',
      seviye: poz.seviye || 1, aciklama: poz.aciklama || '',
      min_maas: poz.min_maas || '', max_maas: poz.max_maas || ''
    });
    setHata(''); setBasari('');
    setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.ad.trim() || !form.kod.trim() || !form.departman_id) {
      setHata('Ad, kod ve departman zorunludur'); return;
    }
    try {
      const url = secili
        ? `${API}/api/organizasyon/pozisyonlar/${secili.id}`
        : `${API}/api/organizasyon/pozisyonlar`;
      const method = secili ? 'PUT' : 'POST';
      const payload = {
        ...form,
        departman_id: parseInt(form.departman_id),
        ust_pozisyon_id: form.ust_pozisyon_id ? parseInt(form.ust_pozisyon_id) : null,
        seviye: parseInt(form.seviye) || 1,
        min_maas: form.min_maas ? parseFloat(form.min_maas) : null,
        max_maas: form.max_maas ? parseFloat(form.max_maas) : null,
      };
      const r = await fetch(url, { method, headers, body: JSON.stringify(payload) });
      const d = await r.json();
      if (!r.ok) { setHata(d.hata || 'Hata oluştu'); return; }
      setBasari(d.mesaj);
      setTimeout(() => { setModalAcik(false); getir(); setHata(''); setBasari(''); }, 600);
    } catch { setHata('Sunucu hatası'); }
  };

  const sil = async (poz) => {
    if (!window.confirm(`"${poz.ad}" pozisyonunu silmek istediğinize emin misiniz?`)) return;
    try {
      const r = await fetch(`${API}/api/organizasyon/pozisyonlar/${poz.id}`, { method: 'DELETE', headers });
      const d = await r.json();
      if (!r.ok) { alert(d.hata); return; }
      getir();
    } catch { alert('Hata oluştu'); }
  };

  const pasifToggle = async (poz) => {
    const eylem = poz.aktif !== 0 ? 'pasife almak' : 'aktife almak';
    if (!window.confirm(`"${poz.ad}" pozisyonunu ${eylem} istediğinize emin misiniz?`)) return;
    try {
      const r = await fetch(`${API}/api/organizasyon/pozisyonlar/${poz.id}`, {
        method: 'PUT', headers,
        body: JSON.stringify({ ...poz, aktif: poz.aktif !== 0 ? 0 : 1 })
      });
      const d = await r.json();
      if (!r.ok) { alert(d.hata || 'Hata oluştu'); return; }
      getir();
    } catch { alert('Hata oluştu'); }
  };

  const kodUret = (ad) => ad.toUpperCase()
    .replace(/Ğ/g,'G').replace(/Ü/g,'U').replace(/Ş/g,'S')
    .replace(/İ/g,'I').replace(/Ö/g,'O').replace(/Ç/g,'C')
    .replace(/[^A-Z0-9]/g,'').slice(0, 8);

  const AgacKarti = ({ poz }) => {
    const dep = departmanlar.find(d => d.id === poz.departman_id);
    const renk = dep?.renk || '#4F46E5';
    const [hover, setHover] = useState(false);

    return (
      <div style={{ marginBottom: '6px' }}>
        <div
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            background: hover ? '#F8FAFF' : poz.aktif === 0 ? '#F9FAFB' : '#fff',
            border: `1.5px solid ${hover ? renk : '#E5E7EB'}`,
            borderLeft: `4px solid ${poz.aktif === 0 ? '#D1D5DB' : renk}`,
            opacity: poz.aktif === 0 ? 0.6 : 1,
            borderRadius: '10px',
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            transition: 'all 0.15s',
            marginLeft: `${poz.derinlik * 28}px`,
            boxShadow: hover ? `0 2px 8px ${renk}20` : '0 1px 3px rgba(0,0,0,0.05)'
          }}
        >
          <div style={{
            background: seviyeRenk(poz.seviye) + '15',
            color: seviyeRenk(poz.seviye),
            borderRadius: '6px', padding: '3px 10px',
            fontSize: '11px', fontWeight: 700, flexShrink: 0
          }}>L{poz.seviye}</div>

          <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: renk, flexShrink: 0 }} />

          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>{poz.ad}</span>
              <span style={{ background: '#F3F4F6', color: '#6B7280', fontSize: '10px', padding: '1px 6px', borderRadius: '3px', fontFamily: 'monospace' }}>{poz.kod}</span>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '3px', flexWrap: 'wrap', alignItems: 'center' }}>
              <span style={{ background: renk + '15', color: renk, fontSize: '11px', padding: '1px 7px', borderRadius: '4px', fontWeight: 600 }}>{poz.departman_ad}</span>
              <span style={{ color: '#9CA3AF', fontSize: '11px' }}>{seviyeAd(poz.seviye)}</span>
              {(poz.min_maas || poz.max_maas) && (
                <span style={{ color: '#059669', fontSize: '11px', fontWeight: 600 }}>
                  💰 {poz.min_maas ? Number(poz.min_maas).toLocaleString('tr-TR') + '₺' : '?'} — {poz.max_maas ? Number(poz.max_maas).toLocaleString('tr-TR') + '₺' : '?'}
                </span>
              )}
            </div>
          </div>

          <div style={{ textAlign: 'center', flexShrink: 0 }}>
            <div style={{
              width: '32px', height: '32px', borderRadius: '50%',
              background: poz.dolu_kisi > 0 ? renk : '#F3F4F6',
              color: poz.dolu_kisi > 0 ? '#fff' : '#9CA3AF',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '13px', fontWeight: 700, margin: '0 auto'
            }}>{poz.dolu_kisi || 0}</div>
            <div style={{ fontSize: '10px', color: '#9CA3AF', marginTop: '2px' }}>kişi</div>
          </div>

          {hover && (
            <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
              <button onClick={() => duzenleAc(poz)} style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Düzenle</button>
              <button onClick={() => pasifToggle(poz)} style={{ background: poz.aktif !== 0 ? '#FEF3C7' : '#F0FDF4', color: poz.aktif !== 0 ? '#92400E' : '#16A34A', border: 'none', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>{poz.aktif !== 0 ? 'Pasife Al' : 'Aktife Al'}</button>
              <button onClick={() => sil(poz)} style={{ background: '#FEF2F2', color: '#DC2626', border: 'none', padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Sil</button>
            </div>
          )}
        </div>

        {poz.cocuklar && poz.cocuklar.length > 0 && (
          <div>
            {poz.cocuklar.map(c => <AgacKarti key={c.id} poz={c} />)}
          </div>
        )}
      </div>
    );
  };

  // Filtreli ağaç: seçili pozisyonların üst zincirini de dahil et
  const filtreliAgacListesi = () => {
    if (!aramaMetni && !filtreDep && !filtreSeviye) return pozisyonlar;
    const eslesen = new Set(filtrelenmis.map(p => p.id));
    const idMap = {};
    pozisyonlar.forEach(p => { idMap[p.id] = p; });
    // Üst pozisyonları da ekle
    filtrelenmis.forEach(p => {
      let cur = idMap[p.ust_pozisyon_id];
      while (cur) { eslesen.add(cur.id); cur = idMap[cur.ust_pozisyon_id]; }
    });
    return pozisyonlar.filter(p => eslesen.has(p.id));
  };
  const agac = agacOlustur(filtreliAgacListesi());

  return (
    <div style={{ padding: '24px', maxWidth: '1100px', margin: '0 auto' }}>

      {/* Başlık */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: '#111827', margin: 0 }}>💼 Pozisyon Yönetimi</h1>
          <p style={{ color: '#6B7280', marginTop: '4px', fontSize: '14px' }}>
            {pozisyonlar.length} pozisyon · {pozisyonlar.filter(p => p.dolu_kisi > 0).length} dolu · {pozisyonlar.filter(p => !p.dolu_kisi).length} boş
          </p>
        </div>
        <button onClick={yeniAc} style={{ background: '#4F46E5', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 600, fontSize: '14px' }}>
          + Yeni Pozisyon
        </button>
      </div>

      {/* Seviye özet kartlar */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '10px', marginBottom: '20px' }}>
        {[1,2,3,4,5].map(sev => {
          const count = pozisyonlar.filter(p => p.seviye === sev).length;
          const aktif = filtreSeviye === String(sev);
          return (
            <div key={sev} onClick={() => setFiltreSeviye(aktif ? '' : String(sev))} style={{
              background: aktif ? seviyeRenk(sev) + '10' : '#fff',
              border: `1.5px solid ${aktif ? seviyeRenk(sev) : '#E5E7EB'}`,
              borderTop: `3px solid ${seviyeRenk(sev)}`,
              borderRadius: '8px', padding: '12px', cursor: 'pointer',
              transition: 'all 0.15s'
            }}>
              <div style={{ fontSize: '20px', fontWeight: 700, color: seviyeRenk(sev) }}>{count}</div>
              <div style={{ fontSize: '11px', fontWeight: 600, color: '#374151', marginTop: '2px' }}>Level {sev}</div>
              <div style={{ fontSize: '10px', color: '#9CA3AF' }}>{seviyeAd(sev)}</div>
            </div>
          );
        })}
      </div>

      {/* Filtre bar */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
          <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }}>🔍</span>
          <input value={aramaMetni} onChange={e => setAramaMetni(e.target.value)} placeholder="Pozisyon ara..."
            style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
        </div>

        <select value={filtreDep} onChange={e => setFiltreDep(e.target.value)}
          style={{ padding: '9px 14px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px' }}>
          <option value="">Tüm Departmanlar</option>
          {departmanlar.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
        </select>

        <div style={{ display: 'flex', border: '1.5px solid #E5E7EB', borderRadius: '8px', overflow: 'hidden' }}>
          {[['agac','🌳 Ağaç'],['liste','📋 Liste']].map(([k,l]) => (
            <button key={k} onClick={() => setGorunum(k)} style={{
              padding: '8px 14px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600,
              background: gorunum === k ? '#4F46E5' : '#fff',
              color: gorunum === k ? '#fff' : '#6B7280'
            }}>{l}</button>
          ))}
        </div>

        {(aramaMetni || filtreDep || filtreSeviye) && (
          <button onClick={() => { setAramaMetni(''); setFiltreDep(''); setFiltreSeviye(''); }}
            style={{ padding: '8px 14px', border: '1.5px solid #E5E7EB', borderRadius: '8px', background: '#fff', color: '#6B7280', cursor: 'pointer', fontSize: '13px' }}>
            ✕ Temizle
          </button>
        )}
      </div>

      {/* İçerik */}
      {yukleniyor ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#9CA3AF' }}>Yükleniyor...</div>
      ) : pozisyonlar.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', background: '#F9FAFB', borderRadius: '12px', border: '2px dashed #E5E7EB' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>💼</div>
          <p style={{ color: '#6B7280', fontWeight: 600 }}>Henüz pozisyon yok</p>
          <button onClick={yeniAc} style={{ marginTop: '12px', background: '#4F46E5', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: '6px', cursor: 'pointer' }}>İlk pozisyonu oluştur</button>
        </div>
      ) : gorunum === 'agac' ? (
        <div style={{ background: '#F9FAFB', borderRadius: '12px', padding: '16px', border: '1px solid #E5E7EB' }}>
          {agac.length === 0
            ? <div style={{ textAlign: 'center', padding: '40px', color: '#9CA3AF' }}>Sonuç bulunamadı</div>
            : agac.map(p => <AgacKarti key={p.id} poz={p} />)
          }
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '8px' }}>
          {filtrelenmis.sort((a,b) => a.seviye - b.seviye || a.ad.localeCompare(b.ad)).map(poz => {
            const dep = departmanlar.find(d => d.id === poz.departman_id);
            const renk = dep?.renk || '#4F46E5';
            return (
              <div key={poz.id} style={{ background: '#fff', borderRadius: '10px', border: '1px solid #E5E7EB', borderLeft: `4px solid ${renk}`, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ background: seviyeRenk(poz.seviye) + '15', color: seviyeRenk(poz.seviye), borderRadius: '6px', padding: '3px 10px', fontSize: '11px', fontWeight: 700, flexShrink: 0 }}>L{poz.seviye}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <span style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>{poz.ad}</span>
                    <span style={{ background: '#F3F4F6', color: '#6B7280', fontSize: '10px', padding: '1px 6px', borderRadius: '3px', fontFamily: 'monospace' }}>{poz.kod}</span>
                    <span style={{ background: renk + '15', color: renk, fontSize: '11px', padding: '1px 7px', borderRadius: '4px', fontWeight: 600 }}>{poz.departman_ad}</span>
                    {poz.ust_pozisyon_ad && <span style={{ color: '#9CA3AF', fontSize: '11px' }}>↑ {poz.ust_pozisyon_ad}</span>}
                  </div>
                </div>
                <div style={{ textAlign: 'center', flexShrink: 0 }}>
                  <div style={{ fontSize: '16px', fontWeight: 700, color: poz.dolu_kisi > 0 ? '#4F46E5' : '#9CA3AF' }}>{poz.dolu_kisi || 0}</div>
                  <div style={{ fontSize: '10px', color: '#9CA3AF' }}>kişi</div>
                </div>
                <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                  <button onClick={() => duzenleAc(poz)} style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Düzenle</button>
                  <button onClick={() => pasifToggle(poz)} style={{ background: poz.aktif !== 0 ? '#FEF3C7' : '#F0FDF4', color: poz.aktif !== 0 ? '#92400E' : '#16A34A', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>{poz.aktif !== 0 ? 'Pasife Al' : 'Aktife Al'}</button>
                  <button onClick={() => sil(poz)} style={{ background: '#FEF2F2', color: '#DC2626', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Sil</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal */}
      {modalAcik && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '540px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 24px' }}>{secili ? '✏️ Pozisyon Düzenle' : '+ Yeni Pozisyon'}</h2>

            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>⚠️ {hata}</div>}
            {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>✅ {basari}</div>}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Pozisyon Adı *</label>
                <input value={form.ad} onChange={e => { const ad = e.target.value; setForm(f => ({ ...f, ad, kod: f.kod || kodUret(ad) })); }}
                  placeholder="örn: Senior Software Engineer"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Kod *</label>
                <input value={form.kod} onChange={e => setForm(f => ({ ...f, kod: e.target.value.toUpperCase().slice(0,8) }))}
                  placeholder="örn: SR-SWE"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', fontFamily: 'monospace', boxSizing: 'border-box' }} />
              </div>

              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Departman *</label>
                <select value={form.departman_id} onChange={e => setForm(f => ({ ...f, departman_id: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                  <option value="">— Departman seçin —</option>
                  {departmanlar.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
                </select>
              </div>

              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Üst Pozisyon</label>
                <select value={form.ust_pozisyon_id} onChange={e => setForm(f => ({ ...f, ust_pozisyon_id: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                  <option value="">— Üst pozisyon yok (en tepe) —</option>
                  {pozisyonlar.filter(p => !secili || p.id !== secili.id).map(p => (
                    <option key={p.id} value={p.id}>{p.ad} ({p.departman_ad})</option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '8px' }}>
                  Seviye: <span style={{ color: seviyeRenk(parseInt(form.seviye)), fontWeight: 700 }}>Level {form.seviye} — {seviyeAd(parseInt(form.seviye))}</span>
                </label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[1,2,3,4,5].map(s => (
                    <button key={s} onClick={() => setForm(f => ({ ...f, seviye: s }))} style={{
                      flex: 1, padding: '8px', borderRadius: '8px', cursor: 'pointer', fontWeight: 700, fontSize: '13px',
                      border: `2px solid ${parseInt(form.seviye) === s ? seviyeRenk(s) : '#E5E7EB'}`,
                      background: parseInt(form.seviye) === s ? seviyeRenk(s) + '15' : '#fff',
                      color: parseInt(form.seviye) === s ? seviyeRenk(s) : '#9CA3AF'
                    }}>L{s}</button>
                  ))}
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Min. Maaş (₺)</label>
                  <input type="number" value={form.min_maas} onChange={e => setForm(f => ({ ...f, min_maas: e.target.value }))} placeholder="0"
                    style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Max. Maaş (₺)</label>
                  <input type="number" value={form.max_maas} onChange={e => setForm(f => ({ ...f, max_maas: e.target.value }))} placeholder="0"
                    style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                </div>
              </div>

              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Açıklama</label>
                <textarea value={form.aciklama} onChange={e => setForm(f => ({ ...f, aciklama: e.target.value }))}
                  rows={3} placeholder="Görev tanımı..."
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }} />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
              <button onClick={() => setModalAcik(false)} style={{ flex: 1, padding: '11px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kaydet} style={{ flex: 2, padding: '11px', borderRadius: '8px', border: 'none', background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '14px' }}>
                {secili ? 'Güncelle' : 'Oluştur'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
